'use client';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { MapPin, LayoutGrid, Sparkles, Compass, Zap } from 'lucide-react';

const features = [
  {
    icon: MapPin,
    title: 'Interactive Maps',
    description: 'Create clear, interactive maps of your church that help visitors and parishioners explore sacred spaces with intention and understanding.',
  },
  {
    icon: LayoutGrid,
    title: 'Zones & Spaces',
    description: 'Organize your church into meaningful zones—nave, sanctuary, chapels, ceilings—so each space can be explored as part of a larger story.',
  },
  {
    icon: Sparkles,
    title: 'Artwork & Stories',
    description: 'Present artwork, relics, and sacred objects with rich context, sharing the history, symbolism, and faith behind every piece.',
  },
  {
    icon: Compass,
    title: 'Guided Discovery',
    description: 'Invite deeper engagement through curated paths and highlights that help people discover details they might otherwise miss.',
  },
  {
    icon: Zap,
    title: 'Simple to Manage',
    description: 'Intuitive admin tools make it easy to add artwork, update stories, and manage maps without technical expertise.',
  },
];

export function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 px-4 bg-[hsl(45,25%,88%)]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center space-y-5 mb-16">
          <h2 className="text-3xl md:text-4xl font-spectral font-semibold">Everything You Need</h2>
          <p className="text-foreground/70 text-lg max-w-2xl mx-auto leading-relaxed">
            Powerful features designed to help you create meaningful connections with your community.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <Card key={feature.title} className="border-0 shadow-none bg-transparent">
                <CardHeader className="px-0">
                  <div className="h-10 w-10 rounded-lg bg-gradient-to-br from-gold/20 to-[hsl(var(--burgundy)/0.15)] flex items-center justify-center mb-4 border border-gold/20">
                    <Icon className="h-5 w-5 text-[hsl(var(--burgundy)/0.8)]" />
                  </div>
                  <CardTitle className="font-spectral font-semibold mb-2">{feature.title}</CardTitle>
                  <CardDescription className="leading-relaxed">{feature.description}</CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
